module.exports = __webpack_public_path__ + "img/benovelty.c45801e4.png";